<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <section>
    <b-row>
      <b-col cols="12">
        <b-tabs>
          <template v-slot:tabs-end>
            <li class="nav-item align-self-center link-title">
              <div style=" border-bottom:2px solid #007BFF; padding-bottom:10px;">友情链接</div>
            </li>
          </template>
        </b-tabs>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-list-group horizontal>
          <b-list-group-item
            style="line-height:32px; font-size:16px;border-bottom: none !important;"
            v-for="(link, index) in links"
          >
            <a v-bind="{ href: link.url }" target="_blank" :key="index">
              {{
              link.name
              }}
            </a>
          </b-list-group-item>
        </b-list-group>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { axiosServer } from '@/api/judge';
import { urls } from '@/api/urls';

export default {
  name: 'LinkComponent',
  props: {},
  data() {
    return {
      links: []
    };
  },

  mounted() {
    this.requestLink();
  },

  unmounted() {},

  created() {},

  methods: {
    requestLink() {
      axiosServer({
        url: urls.link,
        params: { page: 1, pageSize: 10 }
      }).then(resp => {
        this.links = resp.data.page.list;
      });
    }
  }
};
</script>

<style scoped>
.card-body {
  padding: 0;
}

.link-title {
  color: #303133;
  padding-top: 10px;
  font-weight: 600;
  font-size: 16px;
  margin-top: 20px;
}

.list-group-item {
  border: none;
  border-bottom: 1px solid #ebebeb;
  line-height: 1rem;
  font-size: 13px;
}
</style>
